import { render, staticRenderFns } from "./buttonauth.vue?vue&type=template&id=3c2b1874&scoped=true&"
import script from "./buttonauth.vue?vue&type=script&lang=js&"
export * from "./buttonauth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2b1874",
  null
  
)

export default component.exports